var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticClass:"table",attrs:{"data":_vm.allData,"border":""}},[_c('el-table-column',{attrs:{"prop":"s_name","label":"影人名称","align":"center"}}),_c('el-table-column',{attrs:{"prop":"s_count","label":"互动次数","align":"center"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }